import React from 'react';
import { Box, Chip, CircularProgress, CircularProgressProps, Typography } from '@mui/material';
import classNames from 'classnames';
import { useMeetingHubContext } from '../MeetingHubContext';
import { VoteValueType } from 'store/enums/VoteTypes';
import { VotingResult } from 'store/types/Meeting';
import { voteValueLabels } from 'util/meeting';

import styles from './VoteResultView.module.scss';

interface VotingSectionProps {
  votingResult: VotingResult;
}

const progressBarProps: CircularProgressProps = {
  variant: 'determinate',
  size: 200,
  thickness: 6,
};

const VoteResultView: React.FunctionComponent<VotingSectionProps> = ({ votingResult }) => {
  const { canViewAllVoters } = useMeetingHubContext();
  const resultLabel = votingResult.passed ? 'Pass' : 'Fail';
  const percentageYes = Number(votingResult.percentageYes * 100);
  const percentLabel = `${percentageYes.toFixed(0) || 0}%`;

  return (
    <>
      <Typography className="mt-4">{`${votingResult.tally?.yes}-Y ${votingResult.tally?.no}-N Voting Result: ${resultLabel} - ${percentLabel}`}</Typography>
      <Chip color={votingResult.passed ? 'success' : 'error'} label={resultLabel} />
      <Box display={'flex'} alignItems={'center'}>
        <div className={classNames(styles.chartWrapper, 'mt-3')}>
          <CircularProgress
            {...progressBarProps}
            value={100}
            className={classNames(styles.progress, styles.background)}
          />
          <CircularProgress
            {...progressBarProps}
            color={votingResult.passed ? 'success' : 'error'}
            value={percentageYes || 0}
            className={classNames(styles.progress, styles.value)}
          />
          <div className={styles.label}>
            <span className={styles.labelCount}>{percentLabel}</span>
            <div>{voteValueLabels[VoteValueType.Yes]}</div>
          </div>
        </div>
        <div className={styles.legendWrapper}>
          <div className={styles.label}>
            <Typography>{`${votingResult.tally?.yes} - ${voteValueLabels[VoteValueType.Yes]}`}</Typography>
            <Typography>{`${votingResult.tally?.no} - ${voteValueLabels[VoteValueType.No]}`}</Typography>
            {canViewAllVoters && (
              <Typography>{`${votingResult.tally?.abstain} - ${voteValueLabels[VoteValueType.Abstain]}`}</Typography>
            )}
          </div>
        </div>
      </Box>
    </>
  );
};

export default VoteResultView;
